
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2p6LO", function(module, exports) {

$parcel$export(module.exports, "crossDomainExperienceForwarding", () => (parcelRequire("28xsK")).crossDomainExperienceForwarding);

var $28xsK = parcelRequire("28xsK");

});
parcelRegister("28xsK", function(module, exports) {

$parcel$export(module.exports, "crossDomainExperienceForwarding", () => $a9d3fff1e1ae5301$export$13c32e3020be88c7);

var $diaaX = parcelRequire("diaaX");

var $fzXaO = parcelRequire("fzXaO");
const $a9d3fff1e1ae5301$export$13c32e3020be88c7 = (fromExperienceTracker)=>{
    const module = (0, $fzXaO.requireModule)((0, $diaaX.EXPERIENCE_FORWARDING_MODULE_NAME));
    return module ? fromExperienceTracker.subscribe(({ action: action, ...options })=>{
        switch(action){
            case 'taskAbort':
                module.abort({
                    ...options,
                    checkForTimeout: false // disallow `taskAbort` to be converted into `taskFail`
                });
                break;
            case 'taskFail':
                const { error: { message: message, name: name } } = options;
                module.fail({
                    ...options,
                    // Transform the error object as pure object so that it can be transported back to EP on AFP through `window.postMessage`
                    // This is because error is instance of Error class, and non-primitive data is not supported to transport
                    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
                    error: {
                        message: message,
                        name: name
                    }
                });
                break;
            case 'taskStart':
                module.start(options);
                break;
            case 'taskSuccess':
                module.succeed(options);
                break;
        }
    }) : undefined;
};

});



//# sourceMappingURL=crossDomainExperienceForwarding.dbfd47e5.js.map
